import styled from 'styled-components';

import { fontFamilySize, px } from '../../../contrib/ui';

interface IEmptySpotStyled {
  addPlayer?: boolean;
  open?: boolean;
  editMode: boolean;
  buttonMode: boolean;
}

// eslint-disable-next-line no-mixed-operators
export const EmptySpotStyled = styled.div<IEmptySpotStyled>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  height: ${px(100)};

  ${fontFamilySize('Heavy', 16)}
  color: ${props => (props.editMode ? 'var(--mainColor)' : 'var(--dark)')} ;

  border-width: 2px;
  border-style: dashed;
  border-color: ${props => (props.editMode ? 'var(--mainColor)' : 'var(--greyd8)')} ;
  border-radius: 5px;


  &:hover {
    background-color: ${props => (props.editMode && props.buttonMode ? '#ff00000d' : 'white')};
    cursor: ${props => (props.editMode && props.buttonMode ? 'pointer' : 'auto')};
  }

  span {
    position: relative;
    top: 0.13em;
    display:inline-block;
    margin-right: ${px(5)}
  }

`;
